import { render, staticRenderFns } from "./RatingFullTable.vue?vue&type=template&id=9b0ec8ec&scoped=true"
import script from "./RatingFullTable.vue?vue&type=script&lang=js"
export * from "./RatingFullTable.vue?vue&type=script&lang=js"
import style0 from "./RatingFullTable.vue?vue&type=style&index=0&id=9b0ec8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0ec8ec",
  null
  
)

export default component.exports